export enum RiskLevel {
  low = 0,
  medium = 1,
  high = 2
}
